import { appCategories, appEnums, appSettings } from './app-settings';
import { authenticationApi, signInApi, signOutApi } from './authentication-api';
import {
  hostByCountries,
  hostsApi,
  hostSummaryStatistic,
  hostTrendsApi,
} from './hosts-api';
import { ltvStatisticApi, ltvTrendsApi } from './ltv';
import {
  applyOfferGeoProposedBid,
  countryStatisticsApi,
  offerGeoApi,
  offerGeoCountriesApi,
} from './offer-geo-api';
import {
  activateOffer,
  copyOffer,
  geoListByOfferId,
  offerAutoBid,
  offerPartners,
  offerPrices,
  offersApi,
  offersDevices,
  offersShortStat,
  offersTrends,
  pauseOffer,
  trendsManagersApi,
} from './offers-api';
import {
  partnersApi,
  partnersGeoECPM,
  partnersTrends,
  partnersWithoutStatistic,
} from './partners-api';
import {
  allCountriesStatistic,
  rtbApi,
  rtbCountries,
  rtbList,
  rtbSummary,
} from './rtb-api';
import { offerGeoSchedule, offerSchedule } from './schedule';
import { statistic, statisticAndroidVersions } from './statistic';
import {
  trendsActiveUsersAppVersions,
  trendsAndroidVersions,
  trendsApi,
  trendsNetsApi,
  trendsNetsStatisticApi,
  trendsUsersTypeStat,
  trendsStatUsersPackages,
  trendsStat5AndroidVersions,
  trendsStat5CountriesStatistic,
} from './trends-api';
import {
  filterUsers,
  geoListByUserId,
  publishers,
  userPasswordApi,
  usersApi,
  usersExtendedStatistic,
  usersStatistic,
} from './user-api';
import { ipdUserImpressions, userStatistic } from './user-statistic';

export const serviceEndpoints = {
  authenticationApi,
  signInApi,
  signOutApi,
  usersApi,
  filterUsers,
  publishers,
  usersStatistic,
  usersExtendedStatistic,
  userPasswordApi,
  geoListByUserId,
  offersApi,
  copyOffer,
  offerAutoBid,
  geoListByOfferId,
  pauseOffer,
  offerPartners,
  activateOffer,
  offerGeoApi,
  offerGeoCountriesApi,
  countryStatisticsApi,
  applyOfferGeoProposedBid,
  partnersApi,
  partnersGeoECPM,
  partnersTrends,
  partnersWithoutStatistic,
  offersDevices,
  offerPrices,

  statistic,
  statisticAndroidVersions,

  offerSchedule,
  offerGeoSchedule,
  trendsManagersApi,
  offersTrends,
  offersShortStat,

  trendsApi,
  trendsNetsApi,
  trendsAndroidVersions,
  trendsNetsStatisticApi,
  trendsActiveUsersPackages: trendsStatUsersPackages,
  trendsStatUsersAppVersions: trendsActiveUsersAppVersions,
  trendsUsersTypeStat,
  trendsStat5AndroidVersions,
  trendsStat5CountriesStatistic,

  userStatistic,
  ipdUserImpressions,

  rtbApi,
  rtbCountries,
  allCountriesStatistic,
  rtbSummary,
  rtbList,
  hostsApi,
  hostTrendsApi,
  hostByCountries,
  hostSummaryStatistic,

  ltvStatisticApi,
  ltvTrendsApi,

  appSettings,
  appEnums,
  appCategories,
};
